// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__shCSH","addWidgetButton":"Header_addWidgetButton__6OMK5","dashboardTabs":"Header_dashboardTabs__2zFmX","active":"Header_active__31s-l"};